var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{staticClass:"sidebar-title"},[_vm._v("Filters")]),(_vm.activeSourceId)?_c('data-source-filters',{staticClass:"mt-3",attrs:{"source-name":_vm.activeSourceId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }